/**
 * Base64 to Blob converter utility
 * Converts base64 image data to Blob for S3 upload
 */

/**
 * Convert base64 string to Blob
 * @param base64Data - Base64 string (e.g., "data:image/jpeg;base64,/9j/4AAQ...")
 * @returns {Blob} Blob object ready for upload
 */
export const base64ToBlob = (base64Data: string): Blob => {
  const base64Match = base64Data.match(/^data:image\/(\w+);base64,(.+)$/);
  const base64String = base64Match?.[2] ?? base64Data;
  const contentType = base64Match?.[1] ?? 'jpeg';
  
  // Use atob with type assertion to avoid deprecation warning
  const binaryString = (atob as (data: string) => string)(base64String);
  const byteArray = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
  
  return new Blob([byteArray], { type: `image/${contentType}` });
};


